// extracted by mini-css-extract-plugin
export default {"cookieBanner":"CookieBanner_cookieBanner__ckLYH","learnMore":"CookieBanner_learnMore__9wanh","acceptButton":"CookieBanner_acceptButton__OpqEM"};